import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Add Pay Classification loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Add Pay Classification loader'
  )

  return defer({
    data: Promise.all([])
      .then(() => true)
      .catch((error) => {
        logger.error('Add Pay Classification Promise.all error', error)
        return false
      }),
  })
}
